import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setDocFormData } from '../store/actions/housingStockActions';

const useChangeDocModalVisible = () => {
  const dispatch = useDispatch();

  const openModal = useCallback(
    ({ entity, params, attachment, typeId }) => {
      if (!entity) return;

      const data = { entity, params, typeId };

      if (attachment) {
        data.attachment = attachment;
      }

      dispatch(setDocFormData(data));
    },
    [dispatch]
  );

  const closeModal = useCallback(() => {
    dispatch(setDocFormData(null));
  }, [dispatch]);

  return { openModal, closeModal };
};

export default useChangeDocModalVisible;
